import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusLegalComponent } from './status-legal.component';
import { AddStatusLegalComponent } from './add-status-legal/add-status-legal.component';
import { EditStatusLegalComponent } from './edit-status-legal/edit-status-legal.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        StatusLegalComponent,
        AddStatusLegalComponent,
        EditStatusLegalComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [StatusLegalComponent],
})
export class StatusLegalModule { }
